var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-park-outline:circular-connection"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.125 29.5258C12.369 31.2935 15.1435 32.2527 18 32.2483C20.9722 32.2483 23.7075 31.2313 25.875 29.5258M14.25 7.30859C9.03825 8.90984 5.25 13.7616 5.25 19.4983C5.25 20.9421 5.49 22.3296 5.9325 23.6233M21.75 7.30859C26.9618 8.90984 30.75 13.7616 30.75 19.4983C30.75 20.9421 30.51 22.3296 30.0675 23.6233",
    stroke: "#065AD8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.25 26.9995C32.25 28.006 31.854 28.9195 31.209 29.593C30.6067 30.2223 29.8041 30.6223 28.939 30.7242C28.0739 30.8262 27.2003 30.6238 26.4681 30.1518C25.736 29.6799 25.191 28.9677 24.9267 28.1377C24.6625 27.3077 24.6954 26.4115 25.0199 25.6031C25.3444 24.7947 25.9401 24.1245 26.7049 23.7075C27.4697 23.2906 28.3559 23.1529 29.2111 23.3181C30.0664 23.4832 30.8375 23.941 31.392 24.6128C31.9465 25.2846 32.2499 26.1285 32.25 26.9995ZM11.25 26.9995C11.25 28.006 10.854 28.9195 10.209 29.593C9.60667 30.2223 8.80406 30.6223 7.93896 30.7242C7.07387 30.8262 6.20026 30.6238 5.46813 30.1518C4.736 29.6799 4.19101 28.9677 3.92674 28.1377C3.66247 27.3077 3.6954 26.4115 4.01988 25.6031C4.34436 24.7947 4.94014 24.1245 5.70494 23.7075C6.46975 23.2906 7.35585 23.1529 8.21113 23.3181C9.0664 23.4832 9.83749 23.941 10.392 24.6128C10.9465 25.2846 11.2499 26.1285 11.25 26.9995ZM21.75 6.74954C21.75 7.75604 21.354 8.66954 20.709 9.34304C20.1067 9.97231 19.3041 10.3723 18.439 10.4742C17.5739 10.5762 16.7003 10.3738 15.9681 9.90183C15.236 9.42985 14.691 8.71771 14.4267 7.88769C14.1625 7.05766 14.1954 6.16152 14.5199 5.35313C14.8444 4.54474 15.4401 3.87452 16.2049 3.45755C16.9697 3.04058 17.8558 2.90286 18.7111 3.06805C19.5664 3.23324 20.3375 3.69102 20.892 4.3628C21.4465 5.03458 21.7499 5.87846 21.75 6.74954Z",
    stroke: "#065AD8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/Program.3ae20ca7419d3db6166ff7afdf492871.svg";
export { ForwardRef as ReactComponent };